// TE-63: ported from Clinical Outcomes' themeRegistry.ts (CO-348) -- static
// metadata for the Theme Settings colour previews, same catalogue as CO plus
// TemplarEdgeLight/TemplarEdgeDark (TE's own two brand themes -- selectable,
// but not the default; see theme-definitions.css for why).
export const customThemeColors = {
  "TemplarEdgeLight": {
    "primary": "#1D6FA4",
    "secondary": "#14527A",
    "accent": "#56B4D3",
    "base": "#FFFFFF"
  },
  "TemplarEdgeDark": {
    "primary": "#3B8FCC",
    "secondary": "#1D6FA4",
    "accent": "#56B4D3",
    "base": "#0D1E2C"
  },
  "ClinicalOutcomes": {
    "primary": "#1D6FA4",
    "secondary": "#14527A",
    "accent": "#56B4D3",
    "base": "#FFFFFF"
  },
  "ClinicalOutcomesDark": {
    "primary": "#3B8FCC",
    "secondary": "#1D6FA4",
    "accent": "#56B4D3",
    "base": "#0D1E2C"
  },
  "MetropainLight": {
    "primary": "#06A3B0",
    "secondary": "#F8A906",
    "accent": "#06BFC8",
    "base": "#FFFFFF"
  },
  "MetropainDark": {
    "primary": "#06BFC8",
    "secondary": "#06A3B0",
    "accent": "#F8A906",
    "base": "#0D1E2C"
  },
  "viola": {
    "primary": "#742092",
    "secondary": "#c858ba",
    "accent": "#FFC973",
    "base": "#FFE3B3"
  },
  "darkpetals": {
    "primary": "#4D4141",
    "secondary": "#EE534F",
    "accent": "#FD7D96",
    "base": "#212226"
  },
  "embers": {
    "primary": "#FF9677",
    "secondary": "#974063",
    "accent": "#F54768",
    "base": "#41436A"
  },
  "seaside": {
    "primary": "#26648B",
    "secondary": "#4F8FBF",
    "accent": "#53D2DB",
    "base": "#FFE3B3"
  },
  "turtlepowered": {
    "primary": "#E5EEC1",
    "secondary": "#A2D5AC",
    "accent": "#1C1C1E",
    "base": "#1C1C1E"
  },
  "fourseasons": {
    "primary": "#2E9699",
    "secondary": "#A7236F",
    "accent": "#F56C40",
    "base": "#F7DC67"
  },
  "sunset": {
    "primary": "oklch(74.703% 0.158 39.947)",
    "secondary": "oklch(72.537% 0.177 2.72)",
    "accent": "oklch(71.294% 0.166 299.844)",
    "base": "oklch(22% 0.019 237.69)"
  },
  "cafe": {
    "primary": "#7F59B0",
    "secondary": "#63C5EA",
    "accent": "#EA4B8B",
    "base": "#F7F6F4"
  },
  "candlelight": {
    "primary": "#73607C",
    "secondary": "#FA8D70",
    "accent": "#FCC666",
    "base": "#C1B9AE"
  },
  "beachside": {
    "primary": "#3B7197",
    "secondary": "#F8E2BD",
    "accent": "#74BDE0",
    "base": "#FFFFFF"
  },
  "traversecity": {
    "primary": "#5193B3",
    "secondary": "#64C4C3",
    "accent": "#F8D49A",
    "base": "#F7E6CA"
  },
  "rosey": {
    "primary": "#CD184F",
    "secondary": "#E84476",
    "accent": "#FFE3B3",
    "base": "#F76CAF"
  },
  "fruitbasket": {
    "primary": "#E984A2",
    "secondary": "#F8D49A",
    "accent": "#BACB95",
    "base": "#FFFFFF"
  },
  "darkstrawberry": {
    "primary": "#F14666",
    "secondary": "#F14666",
    "accent": "#9DB899",
    "base": "#212226"
  },
  "kiwi": {
    "primary": "#038175",
    "secondary": "#0BB68C",
    "accent": "#94DD8B",
    "base": "#FFFFFF"
  },
  "desertstorm": {
    "primary": "#a4243b",
    "secondary": "#d8911f",
    "accent": "#bd632f",
    "base": "#d8c99b"
  },
  "storm": {
    "primary": "#9aa5ce",
    "secondary": "#565f89",
    "accent": "#bb9af7",
    "base": "#24283b"
  },
  "breeze": {
    "primary": "#6807f0",
    "secondary": "#6b21a8",
    "accent": "#db2777",
    "base": "#f2f2f2"
  },
  "tron": {
    "primary": "#fde047",
    "secondary": "#fdc076",
    "accent": "#fde047",
    "base": "#4b5563"
  },
  "liming": {
    "primary": "#68d813",
    "secondary": "#af8de0",
    "accent": "#aebbf2",
    "base": "#f1f1f9"
  },
  "lavenderfield": {
    "primary": "#67e8f9",
    "secondary": "#6366f1",
    "accent": "#3b82f6",
    "base": "#c084fc"
  },
  "scorchedearth": {
    "primary": "#e8ca96",
    "secondary": "#eab308",
    "accent": "#f97316",
    "base": "#ffedd5"
  },
  "northmelbourne": {
    "primary": "#2563eb",
    "secondary": "#38bdf8",
    "accent": "#60a5fa",
    "base": "#f3f4f6"
  },
  "chauvinist": {
    "primary": "#fb7185",
    "secondary": "#ec4899",
    "accent": "#be123c",
    "base": "#fecdd3"
  },
  "inverselavenderfield": {
    "primary": "#c084fc",
    "secondary": "#6366f1",
    "accent": "#3b82f6",
    "base": "#67e8f9"
  },
  "mauvemist": {
    "primary": "#bfb5f4",
    "secondary": "#182af4",
    "accent": "#ebbffc",
    "base": "#e0e2eb"
  },
  "darkenedlime": {
    "primary": "#6cf7ab",
    "secondary": "#f45f7f",
    "accent": "#ea568a",
    "base": "#43404a"
  },
  "metro90s": {
    "primary": "#89e4f4",
    "secondary": "#cc643f",
    "accent": "#d4ed65",
    "base": "#eeeeee"
  },
  "pumpkin": {
    "primary": "#d38e0c",
    "secondary": "#b2ffd7",
    "accent": "#2b0c89",
    "base": "#462f4c"
  },
  "darkandstormynight": {
    "primary": "oklch(83% 0.128 66.29)",
    "secondary": "oklch(0% 0 0)",
    "accent": "oklch(78% 0.115 274.713)",
    "base": "oklch(29% 0.066 243.157)"
  },
  "luke": {
    "primary": "#bde539",
    "secondary": "#9af4be",
    "accent": "#953bd6",
    "base": "#2e2f38"
  },
  "clearbright": {
    "primary": "#c62179",
    "secondary": "#81d11f",
    "accent": "#ef4575",
    "base": "#fbfbfd"
  },
  "conscripted": {
    "primary": "oklch(70% 0.191 22.216)",
    "secondary": "oklch(70% 0.165 254.624)",
    "accent": "oklch(67% 0.182 276.935)",
    "base": "oklch(98% 0.031 120.757)"
  },
  "citrus": {
    "primary": "#fde047",
    "secondary": "#fdba74",
    "accent": "#ea580c",
    "base": "#fb923c"
  },
  "wascalywabbit": {
    "primary": "#f5f5f4",
    "secondary": "#5f7cbf",
    "accent": "#a419e5",
    "base": "#d1d5db"
  },
  "hotpinkery": {
    "primary": "#f22ffc",
    "secondary": "#00f73d",
    "accent": "#b8ed78",
    "base": "#ece9ec"
  },
  "smoothdream": {
    "primary": "oklch(70% 0.022 261.325)",
    "secondary": "oklch(70% 0.191 22.216)",
    "accent": "oklch(75% 0.183 55.934)",
    "base": "oklch(97% 0.021 166.113)"
  },
  "quietschool": {
    "primary": "oklch(65% 0.241 354.308)",
    "secondary": "oklch(0% 0 0)",
    "accent": "oklch(76% 0.188 70.08)",
    "base": "oklch(98% 0.003 247.858)"
  },
  "halfbot": {
    "primary": "oklch(79% 0.184 86.047)",
    "secondary": "oklch(62% 0.265 303.9)",
    "accent": "oklch(72% 0.219 149.579)",
    "base": "oklch(13% 0.028 261.692)"
  },
  "halfbotlight": {
    "primary": "oklch(55% 0.288 302.321)",
    "secondary": "oklch(55% 0.288 302.321)",
    "accent": "oklch(0% 0 0)",
    "base": "oklch(98% 0.001 106.423)"
  },
  "memenoodle": {
    "primary": "oklch(83% 0.128 66.29)",
    "secondary": "oklch(89% 0.196 126.665)",
    "accent": "oklch(85% 0.138 181.071)",
    "base": "oklch(97% 0.014 254.604)"
  },
  "smartprime": {
    "primary": "oklch(89% 0.196 126.665)",
    "secondary": "oklch(82% 0.111 230.318)",
    "accent": "oklch(86% 0.127 207.078)",
    "base": "oklch(98% 0 0)"
  },
  "fireside": {
    "primary": "oklch(79% 0.209 151.711)",
    "secondary": "oklch(70% 0.04 256.788)",
    "accent": "oklch(71% 0.202 349.761)",
    "base": "oklch(26% 0.079 36.259)"
  },
  "wigglydoctor": {
    "primary": "oklch(70% 0.165 254.624)",
    "secondary": "oklch(78% 0.154 211.53)",
    "accent": "oklch(67% 0.182 276.935)",
    "base": "oklch(98% 0.018 155.826)"
  },
  "redvelvet": {
    "primary": "oklch(51% 0.222 16.935)",
    "secondary": "oklch(51% 0.262 276.966)",
    "accent": "oklch(64% 0.222 41.116)",
    "base": "oklch(28% 0.109 3.907)"
  },
  "swagfade": {
    "primary": "oklch(62% 0.214 259.815)",
    "secondary": "oklch(65% 0.241 354.308)",
    "accent": "oklch(76% 0.188 70.08)",
    "base": "oklch(12% 0.042 264.695)"
  },
  "caramellatte": {
    "primary": "oklch(0% 0 0)",
    "secondary": "oklch(22.45% 0.075 37.85)",
    "accent": "oklch(46.44% 0.111 37.85)",
    "base": "oklch(98% 0.016 73.684)"
  },
  "dim": {
    "primary": "oklch(86.133% 0.141 139.549)",
    "secondary": "oklch(73.375% 0.165 35.353)",
    "accent": "oklch(74.229% 0.133 311.379)",
    "base": "oklch(30.857% 0.023 264.149)"
  },
  "nord": {
    "primary": "oklch(59.435% 0.077 254.027)",
    "secondary": "oklch(69.651% 0.059 248.687)",
    "accent": "oklch(77.464% 0.062 217.469)",
    "base": "oklch(95.127% 0.007 260.731)"
  },
  "abyss": {
    "primary": "oklch(92% 0.2653 125)",
    "secondary": "oklch(83.27% 0.0764 298.3)",
    "accent": "oklch(43% 0 0)",
    "base": "oklch(20% 0.08 209)"
  },
  "silk": {
    "primary": "oklch(23.27% 0.0249 284.3)",
    "secondary": "oklch(23.27% 0.0249 284.3)",
    "accent": "oklch(23.27% 0.0249 284.3)",
    "base": "oklch(97% 0.0035 67.78)"
  },
  "firstpanda": {
    "primary": "oklch(70% 0.165 254.624)",
    "secondary": "oklch(75% 0.183 55.934)",
    "accent": "oklch(75% 0.183 55.934)",
    "base": "oklch(13% 0.028 261.692)"
  },
  "quietsocks": {
    "primary": "oklch(62% 0.265 303.9)",
    "secondary": "oklch(70% 0.213 47.604)",
    "accent": "oklch(79% 0.184 86.047)",
    "base": "oklch(98% 0.022 95.277)"
  },
  "carbonbender": {
    "primary": "oklch(78% 0.154 211.53)",
    "secondary": "oklch(76% 0.177 163.223)",
    "accent": "oklch(75% 0.183 55.934)",
    "base": "oklch(14% 0.004 49.25)"
  },
  "maybecoffee": {
    "primary": "oklch(87% 0.15 154.449)",
    "secondary": "oklch(80% 0.105 251.813)",
    "accent": "oklch(80% 0.114 19.571)",
    "base": "oklch(55% 0.135 66.442)"
  },
  "silvermedal": {
    "primary": "oklch(78% 0.154 211.53)",
    "secondary": "oklch(0% 0 0)",
    "accent": "oklch(0% 0 0)",
    "base": "oklch(98% 0 0)"
  }
} as const
export const builtInThemeNames = [
  "light",
  "dark",
  "cupcake",
  "bumblebee",
  "emerald",
  "corporate",
  "synthwave",
  "retro",
  "cyberpunk",
  "valentine",
  "halloween",
  "garden",
  "forest",
  "aqua",
  "lofi",
  "pastel",
  "fantasy",
  "wireframe",
  "black",
  "luxury",
  "dracula",
  "cmyk",
  "autumn",
  "business",
  "acid",
  "lemonade",
  "night",
  "coffee",
  "winter"
] as const
